export interface IdNameModel {
  id: number;
  name: string;
  accountManagerId?: number;
  dependentId?: number;
  extraField?: boolean;
  age?: number;
}
